/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_SuppliersInputs */

const en_waiting_on_suppliers = /** @type {(inputs: Waiting_On_SuppliersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on the suppliers`)
};

/**
* | output |
* | --- |
* | "Waiting on the suppliers" |
*
* @param {Waiting_On_SuppliersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_suppliers = /** @type {((inputs?: Waiting_On_SuppliersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_SuppliersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_suppliers(inputs)
});